import Head from 'next/head';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import PageHero from '@/components/page-hero';
import { loadMessages } from '@/lib/messages';
import { up } from '@/themes';

const Message = styled(PageHero)`
  && {
    padding-bottom: 96px;
    padding-top: 96px;

    ${up.sm} {
      padding-bottom: 160px;
      padding-top: 160px;
    }
  }
`;

/** Props for a catalogue page that must not call the commerce API. */
export const maintenancePageProps = (locale) => ({
  props: {
    maintenance: true,
    messages: loadMessages(locale),
  },
});

const MaintenanceNotice = () => {
  const t = useTranslations('maintenancePage');

  return (
    <>
      <Head>
        <title key="title">{`${t('title')} - Bidali`}</title>
      </Head>
      <Message
        actions={[{ label: t('home'), href: '/' }]}
        align="center"
        description={t('description')}
        eyebrow={t('eyebrow')}
        title={t('title')}
      />
    </>
  );
};

export default MaintenanceNotice;
